import sampleTestActions from "./actions";
import axios from "axios";
import { takeEvery, call, all, put, delay } from "redux-saga/effects";
import { API_URL } from "../../utils/constants";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import Cookies from "js-cookie";
import { EncryptObjectFunction } from "../../utils/cryptoFunction";

const sampleTestSagas = function* () {
  yield all([
    yield takeEvery(sampleTestActions.GET_SAMPLE_QUESTIONS, getSampleQuestions),
    yield takeEvery(sampleTestActions.GET_SAMPLE_SUBMIT_ANSWER, submitAndGetSampleQuestion)
  ])
}

const getSampleQuestions = function*(data){
  
  const { payload } = data;
  const { navigate } = payload;
  try{
    const result = yield call(() =>
      axios.post(`${API_URL}/api/exam/start-sample-exam`, payload.data)
    );

    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );

    yield put({
      type: sampleTestActions.SET_SAMPLE_QUESTIONS,
      payload: result?.data?.code === "OK" ? decodedResult : [],
    });
    if (result?.data?.code === "OK") {
      const queryParams = {
        SrNo: decodedResult?.questionData?.srNo,
        lang: `${payload?.formData?.language}`,
        img: `${payload?.formData?.imageSize}`,
        ans: decodedResult?.questionData?.selectedAnswer,
      };
      
      const encryptedParans = EncryptObjectFunction(queryParams);
      navigate(
        `/${Cookies.get("test_engine_project")}/sample-test?qNo=${encryptedParans}`
      );
    }
  }catch(err){
    console.log(err);
  }
}

const submitAndGetSampleQuestion = function*(data) {
  const { payload } = data;
  const { navigate, handleSelectedValue, queryParams, action,markAction, radio } = payload;
  let status;
  if(action === 'next'){
    status = 'answered'
  }
  try{
    const result = yield call(() =>
      axios.post(`${API_URL}/api/exam/submit-sample-answer`, payload.data)
    );
    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );
    
    yield put({
      type: sampleTestActions.SET_SAMPLE_QUESTIONS,
      payload: result?.data?.code === "OK" ? {...decodedResult, status} : [],
    });
    if (result?.data?.code === "OK") {
      const searchParams = {
        ...queryParams,
        selectedAnswer: decodedResult?.questionData?.selectedAnswer,
      };
      const encryptedParans = EncryptObjectFunction(searchParams);
      navigate(
        `/${Cookies.get("test_engine_project")}/sample-test?qNo=${encryptedParans}`
      );
      if(!markAction && !radio){
        handleSelectedValue("");
      }
      // if(isLastQn){
      //   navigate(`/${Cookies.get('test_engine_project')}/home`)
      // }
    }
  }catch(err){
    console.log(err);
  }
}

export default sampleTestSagas;